import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  return {
    user: searchParams.get('user') || '',
    bg: searchParams.get('bg') || '1',
    phoneNumber,
    title: searchParams.get('title'),
    socials: searchParams.get('socials'),
    qrTitle1: searchParams.get('qrTitle1'),
    qrCode1: searchParams.get('qrCode1'),
    qrTitle2: searchParams.get('qrTitle2'),
    qrCode2: searchParams.get('qrCode2'),
    startFrom: searchParams.get('startFrom')
      ? parseInt(searchParams.get('startFrom') || '')
      : 2,
    duration: searchParams.get('duration')
      ? parseInt(searchParams.get('duration') || '')
      : 10000,
    carousel: searchParams.get('carousel') || '1',
    repeatCount: parseInt(searchParams.get('repeatCount') || '') || 10,
    speedSlow: searchParams.get('speedSlow')
      ? parseInt(searchParams.get('speedSlow') || '')
      : 2000,
    phoneNumberFontSize: searchParams.get('phoneNumberFontSize') || '5',
    titleFontSize: searchParams.get('titleFontSize') || '5',
    sizeQR: searchParams.get('sizeQR') || '28',
    paddingQR: searchParams.get('paddingQR') || '0',
    logo: searchParams.get('logo') || null,
    sizeLogo: searchParams.get('sizeLogo') || '40',
  };
};
